export default __webpack_public_path__ + "static/media/houm.11e364f7.png";